import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import "@theStellarBlueprint/Store/Reducer";
import { css } from "styled-components";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}
// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const styleExtensions = require.context("./StyleExtensions", true);
styleExtensions.keys().forEach(key => styleExtensions(key));

setPostStyleGuideTheme({
    // specifies primary colors are not editable & fixed to these values
    typography: {
        fontFamilyImportUrl:
            "https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,700,700i|Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap",
        body: {
            fontFamily: "Roboto, Arial",
        },
        headerPrimary: {
            fontFamily: "Roboto, Arial",
        },
        headerSecondary: {
            fontFamily: "Roboto, Arial",
            weight: 600,
        },
        headerTertiary: {
            fontFamily: "Roboto, Arial",
        },
    },
    focus: {
        color: "#808080",
        width: "1px",
    },
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 732, 990, 1440],
    },
    button: {
        primary: {
            hoverStyle: {
                // backgroundColor: "#1717cc",
                backgroundColor: "#1111e0",
                textDecoration:"underline"
                
            },
            activeMode:"none"
        },
        secondary:{
            hoverStyle:{
                transform:"perspective(1px) scale(0.98);",
                border: "2px solid #0000FF"
            }
        }
    },
});

setPreStyleGuideTheme({
    // specifies secondary colors are editable
    colors: {
        primary: {
            main: "#0000ff",
            contrast: "#FFFFFF",
        },
        secondary: {
            main: "#06274C",
            contrast: "#193166",
        },
    },
    button: {
        secondary: {
            css: css`
                background: transparent;
            `,
            hoverStyle: {
                backgroundColor: "#F1F1F1",
                borderColor: "#91A2A4",
            },
        },
    },
});
